import { AbbreviationKey } from 'application/repositories/dictionaries';
import { DictionaryInterface } from 'application/repositories/dictionaryRepository';

export const Abbreviation = (dictionary: Partial<DictionaryInterface>, abbrevationKey: AbbreviationKey): string => {
	return `<abbr title=${dictionary.getExplainer(abbrevationKey)}>
				${dictionary.getAbbreviation(abbrevationKey)}
			</abbr>`;
};
